import React, { memo } from "react";
import { useSelector } from "react-redux";

import styles from "./left-column.module.scss";
import { CallListComponent } from "./call-list/call-list.component";
import LeftColumnHeader from "./left-column-header/left-column-header.component";
import ChatListComponent from "./chat-list/chat-list.component";
import NewChatButtonComponent from "./new-chat-button/new-chat-button.component";

import { ApplicationStore } from "~/app/application.store";
import { ViewsApp } from "~/app/views/views.store";

const LeftColumnComponent: React.FC = memo(() => {
  const ViewIsOpen: ViewsApp = useSelector((state: ApplicationStore) => state.views.viewIsOpen);

  return (
    <div className={styles.leftColumn}>
      <LeftColumnHeader />
      {ViewIsOpen === "Calls" ? <CallListComponent /> : <ChatListComponent />}
      {/* {props.isOpenSearchWrapper === true ? <SearchContainer /> : <ChatList />} */}
      <NewChatButtonComponent />
    </div>
  );
});

LeftColumnComponent.displayName = "LeftColumnComponent";

export default LeftColumnComponent;
